// Utility function for UploadFile helper text logic
function getUploadFileHelperText({
  variant,
  Constants,
  fileError,
  helperText,
  customErrorMessages
}) {
  if (variant === Constants.Complete) {
    return null;
  }
  if (Object.keys(fileError).length > 0) {
    // If there's a custom helperText prop and we have an error, prioritize the prop
    if (helperText && fileError.feedbackType === Constants.Error) {
      return helperText;
    }
    if (customErrorMessages) {
      const msg = (fileError?.helperText?.toLowerCase && fileError.helperText.toLowerCase()) || '';
      if ((msg.includes('file type') || msg.includes('status code 400')) && customErrorMessages.wrongFormat) {
        return customErrorMessages.wrongFormat;
      }
      if (msg.includes('format') && customErrorMessages.wrongFileType) {
        return customErrorMessages.wrongFileType;
      }
    }
    return fileError?.helperText;
  }
  return helperText;
}

export default getUploadFileHelperText; 